import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  ManagerAdd,
} from 'imports/ComponentsImports';

import {
  LoadingDialog,
  AlertDialog,
  AlertDialogOneButton,
  PrimaryButton,
  IconWithTooltip
} from 'imports/DesignImports';

import {
  FloatingActionButton,
  CircularProgress,
  Divider,
} from 'material-ui';

import {
  ContentAddIcon,
  TooltipIcon,
} from 'imports/IconsImports';

const styles = {
  tabsActive:{
    backgroundColor: 'black',
    height: '3px'
  },
  tabWhite: {
    backgroundColor: 'white',
    color: 'black'
  },
  addButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '25px'
  },
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '60px',
  },
  saveButton: {
    backgroundColor: '#22aa99',
    color: 'white',
    width: '300px',
    fontFamily: 'Lato'
  },
  managementControl: {
    display: 'flex',
    alignItems: 'center',
  }
};

class CompanyManagers extends Component {
  constructor(props){
    super(props);
    this.state = {
      areaError: false,
      areaLoading: true,
      managersError: false,
      managersLoading: true,
      managersData: [],
      managersComponents: [],
      snackBarOpen: false,
      snackBarMessage: "",
      loadingDialog: false,
      alertDialog: false,
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      currentStage: this.props.cookies.get('current_stage'),
    }
  }

  componentDidMount() {
    this.getAreas();
  }

  render() {
    if(this.state.areaError || this.state.managersError){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los gerentes de tu empresa. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.areaLoading || this.state.managersLoading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div>
        <div style={styles.managementControl}>
          <h3>Finanzas</h3>
        </div>
          {this.state.managersComponents[0]}
          <Divider />
          <h3>Gerencias <IconWithTooltip icon={<TooltipIcon style={{color: '#212F55'}}/>} tooltip="Agrega a los gerentes que forman parte del comité de innovación."/></h3>
          {this.state.managersComponents.filter((component, i) => component !== null && i !== 0).map(component => component)}

          <div style={styles.addButtonContainer}>
            <FloatingActionButton backgroundColor='#22aa99' mini={true} onClick={this.addManager}>
              <ContentAddIcon/>
            </FloatingActionButton>
          </div>
          <div style={styles.saveButtonContainer}>
            <PrimaryButton label="Guardar" onClick={this.send}/>
          </div>
          { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
          { this.state.alertDialog ?
            <AlertDialog
              title={this.state.alertTitle}
              message={this.state.alertMessage}
              acceptLabel={this.state.acceptLabel}
              cancelLabel={this.state.cancelLabel}
              confirm={this.state.confirm}
              cancel={this.state.cancel}/> :
              null }
          { this.state.alertDialogOneButton ?
            <AlertDialogOneButton
              title={this.state.alertTitle}
              message={this.state.alertMessage}
              acceptLabel={this.state.acceptLabel}
              confirm={this.state.confirm}/> :
              null }
      </div>
    );
  }

  reloadPage = () => {
    if(this.props.history.location.pathname === '/home')
      window.location.reload();
    else
      this.props.history.push('/home');
  }

  handleRequestClose = () => {
    this.setState({
      snackBarOpen: false,
      snackBarMessage: ""
    })
  }

  addManager = () => {
    var newState = this.state;
    newState.managersData.push({
      area: this.state.areas[0].name,
      first_name: '',
      last_name: '',
      email: '',
      show: true,
      is_old: false,
      updated: false
    })
    let componentIndex = this.state.managersComponents.length;
    newState.managersComponents.push(
      <ManagerAdd areas={this.state.areas}
        key={componentIndex}
        handleChange={(event) => this.handleChange(event, componentIndex)}
        handleSelectChange={(event, index, value) => this.handleSelectChange(event, index, value, componentIndex)}
        hide={() => this.hide(componentIndex)}/>
    );
    this.setState(newState)
  }

  getAreas = () => {
    let token = this.props.cookies.get('token');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.areas)
    .then((response) => {
      this.setState({
        areas: response.data.filter(area => area.name !== 'Innovación' && area.name !== 'Innspiral'),
        areaError: false,
        areaLoading: false,
      });
      this.getManagers();
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        areaError: true,
        areaLoading: false,
      })
    });
  }

  getManagers = () => {
    let token = this.props.cookies.get('token');
    let user = this.props.cookies.get('user');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.companyData(user.company_id))
    .then((response) => {
      if(response.data.managers.length <= 0){
        this.setEmptyManagers();
      }
      else{
        this.setOldManagers(response.data.managers);
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        managersError: true,
        managersLoading: false
      })
    });
  }

  setEmptyManagers = () => {
    var newState = this.state;
    newState.managersError = false;
    newState.managersLoading = false;
    // Finance
    newState.managersData.push({
      area: 'Finanzas',
      first_name: '',
      last_name: '',
      email: '',
      show: true,
      is_old: false,
      updated: false
    });
    newState.managersComponents.push(
      <ManagerAdd areas={this.state.areas}
      key={0}
      mandatory={true}
      handleChange={(event) => this.handleChange(event, 1)}
      handleSelectChange={(event, index, value) => this.handleSelectChange(event, index, value, 1)}
      hide={() => this.hide(1)}/>
    );
    // First empty
    newState.managersData.push({
      area: this.state.areas[0].name,
      otherArea: '',
      first_name: '',
      last_name: '',
      email: '',
      show: true,
      is_old: false,
      updated: false
    });
    newState.managersComponents.push(
      <ManagerAdd areas={this.state.areas}
      key={1}
      mandatory={false}
      handleChange={(event) => this.handleChange(event, 2)}
      handleSelectChange={(event, index, value) => this.handleSelectChange(event, index, value, 2)}
      hide={() => this.hide(2)}/>
    );
    this.setState(newState)
  }

  setOldManagers = (managers) => {
    var newState = this.state;
    newState.managersError = false;
    newState.managersLoading = false;
    managers.forEach((manager, mIndex) => {
      if(manager.area === 'Finanzas'){
        newState.managersData.push({
          id: manager.id,
          area: manager.area,
          first_name: manager.first_name,
          last_name: manager.last_name,
          email: manager.email,
          show: true,
          is_old: true,
          updated: false
        });
        newState.managersComponents.unshift(
          <ManagerAdd areas={this.state.areas}
          manager={manager}
          mandatory={true}
          key={manager.id}
          handleChange={(event) => this.handleChange(event, mIndex)}
          handleSelectChange={(event, index, value) => this.handleSelectChange(event, index, value, mIndex)}
          hide={() => this.hide(mIndex)}/>
        );
      }
      else{
        newState.managersData.push({
          id: manager.id,
          area: manager.area,
          otherArea: '',
          first_name: manager.first_name,
          last_name: manager.last_name,
          email: manager.email,
          show: true,
          is_old: true,
          updated: false
        });
        newState.managersComponents.push(
          <ManagerAdd areas={this.state.areas}
          manager={manager}
          mandatory={false}
          key={manager.id}
          handleChange={(event) => this.handleChange(event, mIndex)}
          handleSelectChange={(event, index, value) => this.handleSelectChange(event, index, value, mIndex)}
          hide={() => this.hide(mIndex)}/>
        );
      }
    })
    this.setState(newState)
  }

  send = () => {
    this.setState({loadingDialog: true});
    let totalData = {
      new_managers: [],
      deleted_managers: [],
      updated_managers: [],
    }

    var areaSet = new Set();
    for (var i = 0; i < this.state.managersData.length; i++) {
      if(areaSet.has(this.state.managersData[i].area)){
        this.setState({
          alertDialogOneButton: true,
          alertTitle: '¡Error!',
          alertMessage: 'Hay una o más áreas con más de 1 gerente asignado',
          acceptLabel: 'Aceptar',
          confirm: () => this.setState({alertDialogOneButton: false}),
          loadingDialog: false,
        })
        return;
      }
      areaSet.add(this.state.managersData[i].area);
    }

    this.state.managersData.forEach((data) => {
      if(data.otherArea && data.otherArea !== '')
        data.area = data.otherArea;
      if(data.show && !data.is_old)
        totalData.new_managers.push(data)
      else if(data.show && data.updated)
        totalData.updated_managers.push(data)
      else if(!data.show && data.is_old)
        totalData.deleted_managers.push(data)
    });

    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });

    connection.post(routes.companyData(this.state.user.company_id), totalData)
    .then((responses) => {
      if(this.state.currentStage.stage.name === 'CG'){
        connection.patch(routes.nextStage(this.state.user.company_id))
        .then((response) => {
          this.props.cookies.set('current_stage', JSON.stringify(response.data), { path: '/' });
          this.setState({
            alertDialog: true,
            alertTitle: '¡Datos guardados!',
            alertMessage: 'Se han guardado los gerentes',
            acceptLabel: 'Ir al inicio',
            cancelLabel: 'Hacer cambios',
            confirm: this.reloadPage,
            cancel: () => this.setState({alertDialog: false}),
            loadingDialog: false,
          })
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            alertDialogOneButton: true,
            alertTitle: '¡Error!',
            alertMessage: 'Hubo un error al guardar lo gerentes, intenta nuevamente',
            acceptLabel: 'Aceptar',
            confirm: () => this.setState({alertDialogOneButton: false}),
            loadingDialog: false,
          })
        })
      }
      else {
        this.setState({
          alertDialog: true,
          alertTitle: '¡Datos guardados!',
          alertMessage: 'Se han guardado los gerentes',
          acceptLabel: 'Ir al inicio',
          cancelLabel: 'Hacer cambios',
          confirm: this.reloadPage,
          cancel: () => this.setState({alertDialog: false}),
          loadingDialog: false,
        })
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        alertDialogOneButton: true,
        alertTitle: '¡Error!',
        alertMessage: 'Hubo un error al guardar lo gerentes, intenta nuevamente',
        acceptLabel: 'Aceptar',
        confirm: () => this.setState({alertDialogOneButton: false}),
        loadingDialog: false,
      })
    });
  }

  changeCurrency = (currency) => {
    this.setState({currency})
  }

  hide = (componentIndex) => {
    var newState = this.state;
    newState.managersData[componentIndex].show = false;
    newState.managersComponents[componentIndex] = null;
    this.setState(newState)
  }

  handleChange = (event, componentIndex) => {
    var newState = this.state;
    if(!newState.managersData[componentIndex].updated) newState.managersData[componentIndex].updated = true;
    newState.managersData[componentIndex][event.target.name] = event.target.value;
    this.setState(newState);
  }

  handleSelectChange = (event, index, value, componentIndex) => {
    var newState = this.state;
    if(!newState.managersData[componentIndex].updated) newState.managersData[componentIndex].updated = true;
    newState.managersData[componentIndex].area = value;
    newState.managersData[componentIndex].otherArea = '';
    this.setState(newState);
  }
}

export default withCookies(CompanyManagers);



// WEBPACK FOOTER //
// ./src/components/setup/CompanyManagers.js